export default {corgi:{petition_details:{endorsements:{read_full:'Read full endorsement',show_less:'Show less'}}}};